import type { ObjectValuesType } from '@app/types'

export const EXTERNAL_PRODUCT_STATUS = {
  confirmed: 'confirmed',
  confirmedByLenta: 'confirmedByLenta',
  notConfirmed: 'notConfirmed'
} as const

export const EXTERNAL_PRODUCTS_STATUS_TITLE: Record<ObjectValuesType<typeof EXTERNAL_PRODUCT_STATUS>, string> = {
  confirmed: 'подтвержден',
  confirmedByLenta: 'подтвержден',
  notConfirmed: 'не подтвержден'
} as const
